export default __webpack_public_path__ + "static/media/switch-2.413aa61b.svg";